var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5059_39332)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.437 6.22074H10.7166V11.3244C10.7166 11.8422 10.2968 12.2615 9.77949 12.2615H7.22156C6.70432 12.2615 6.28445 11.8422 6.28445 11.3244V6.22074H4.56461C4.27969 6.22074 4.02356 6.04919 3.914 5.7859C3.80559 5.52367 3.86591 5.22053 4.06722 5.01922L8.00325 1.08271C8.27815 0.808366 8.72349 0.808366 8.99899 1.08271L12.9343 5.01922C13.1357 5.22053 13.196 5.52315 13.087 5.7859C12.9775 6.04868 12.722 6.22074 12.437 6.22074Z",
    fill: "#808D9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.845297 8.13379C1.31168 8.13379 1.69 8.51219 1.69 8.97905V12.5134C1.69 13.5722 2.5519 14.4335 3.6107 14.4335H13.3894C14.4482 14.4335 15.3095 13.5722 15.3095 12.5134V8.97905C15.3095 8.51219 15.6884 8.13379 16.1547 8.13379C16.6216 8.13379 17 8.51219 17 8.97909V12.5134C17 14.5043 15.3803 16.1241 13.3894 16.1241H3.6107C1.61977 16.1241 0 14.5043 0 12.5134V8.97909C0 8.51219 0.378401 8.13379 0.845297 8.13379Z",
    fill: "#808D9E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5059_39332"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white",
    transform: "matrix(-1 0 0 1 17 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadArrow);
export default __webpack_public_path__ + "static/media/upload-arrow.5bed2c3628fbee21da293add10ea2fca.svg";
export { ForwardRef as ReactComponent };